import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { isEmpty } from "lodash";

const TrackStatusCard = ({
  header,
  stateIcon,
  statusIcon,
  active,
  details,
  handleOpen,
}) => {
  return (
    <Box
      sx={{
        width: "180px",
        maxWidth: 200,
        position: "relative",
        maxHeight: 200,
        flexShrink: 0,
      }}
    >
      <Card variant="outlined" sx={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "white",
            zIndex: 1,
          }}
        >
          {statusIcon}
        </div>
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px",
            gap: "px",
            // border:"1px solid red",
          }}
        >
          {stateIcon}
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.75rem", // Adjusted font size
              fontWeight: "normal",
              margin: 0,
              textAlign: "center",
            }}
          >
            {header}
          </Typography>
        </CardContent>

        {/* "Details" Link at Bottom-Right */}
        {!isEmpty(details) ? (
          <CardActions
            sx={{ justifyContent: "flex-end", padding: "1px 4px 0px 0px" }}
          >
            {/* Reduced padding */}
            <Button
              sx={{
                textDecoration: "none",
                color: "#1976d2",
                cursor: "pointer",
                fontSize: "0.75rem",
                backgroundColor: "transparent",
                boxShadow: "none",
                textTransform: "none",
                padding: 0,
                minWidth: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                  textDecoration: "underline",
                },
              }}
              disabled={!active}
              onClick={handleOpen}
            >
              Details
            </Button>
          </CardActions>
        ) : (
          <CardActions>
            <Button disabled></Button>
          </CardActions>
        )}
      </Card>
    </Box>
  );
};

export default TrackStatusCard;
